import { http } from "../../../shared/services/http.service";
import { FlashboardParamsModel } from "../models/flashboard-params.model";

export const submitPinApi = async (data: FlashboardParamsModel) =>
  http({ url: "pin", method: "POST", auth: false, data });
